import _ from "lodash";
export const formatData = (obj) => {
  let objkey;
  let newRows = [];
  let rowObj1 = {};

  _.forEach(obj.data, function (value, key) {
    if (!value || typeof value !== 'object') {
      return; // Skip invalid entries
    }
    
    rowObj1 = {}; // Reset for each record
    
    // First, preserve the id if it exists at the top level of the record
    if (value.id) {
      rowObj1.id = String(value.id);
    }
    
    // Process the record object
    _.forEach(value, function (val, index) {
      if (index === "id") {
        // Preserve id from the record
        if (val) {
          rowObj1.id = String(val);
        }
      } else if (index === "data" && Array.isArray(val)) {
        // Process the nested data array with name/value pairs
        _.forEach(val, function (va) {
          if (va && va.name !== undefined && va.name !== null) {
            objkey = va["name"];
            // Only set value if it's not null/undefined
            if (va["value"] !== undefined && va["value"] !== null) {
              rowObj1["" + objkey + ""] = va["value"];
            }
          }
        });
      }
    });
    
    // Final check: ensure id is always present (critical for Material-UI DataGrid)
    if (!rowObj1.id) {
      // Try to get id from the original value object
      rowObj1.id = value.id || value.Id || `row-${key}-${Date.now()}`;
    }
    
    // Ensure id is always a string
    rowObj1.id = String(rowObj1.id);
    
    // Only add the row if it has at least an id
    if (rowObj1.id) {
      newRows.push(rowObj1); // Use push instead of index assignment to avoid sparse arrays
    }
  });
  
  // Return the array (already filtered)
  return newRows;
};

export const getColum = () => {
  // This is intentional
};

export const getSonicrow = (obj) => {
  let rowObj = {
    id: "",
    formName: "",
    type: "Wizard Entry",
    primaryEntity: "Contact",
    launch: "",
    submissionName: "",
    status: "",
    formId: "",
  };
  _.forEach(obj, function (value, key) {
    if (
      ["formName", "id", "submissionName", "status", "formId"].includes(key)
    ) {
      rowObj[key] = value;
    }
  });
  return rowObj;
};

export const getApplicationrow = (obj) => {
  let rowObj = {};
  let rows = [];
  let statusName;
  _.forEach(obj.data, function (value) {
    switch (value.data[2].value) {
      case 100000000:
        statusName = "Pending";
        break;
      case 100000001:
        statusName = "Complete";
        break;
      case 100000002:
        statusName = "Cancelled";
        break;
      default:
    }
    rowObj = {
      id: value.id,
      ctpt_name: value.data[0].value,
      _ctpt_sonicwebformid_value: value.data[1].value,
      ctpt_submissionstatus: statusName,
      ctpt_sonicwebformsubmissionid: value.data[3].value,
      ctpt_submissiondate: value.data[4].value,
    };
    rows.push(rowObj);
  });
  return rows;
};
